/** @jsx jsx */
/* eslint-disable no-use-before-define,no-empty-pattern */
import { jsx } from '@emotion/core'
import React from 'react'
import { listCss } from './style'
import { fmt, Flyout, isNumeric } from '../../twd'

export const Detail = ({detail, note, setNote, isNote}) => {

    const ordStatusDesc = !detail.ordStatusDesc ? fmt.empty()
        : detail.ordStatusDesc==='Filled' ? 'Executed'
        : detail.ordStatusDesc

    const isAuction = detail.netMoney === 'Auction'

    return <React.Fragment>
        <div className='row bottom-border-row'>
        <div className="col-md-9 col-xs-12">
            <h3 style={{margin:0}}><b>{detail.issue}</b></h3>
            {detail.issuedata.warningText}
        </div>
        <div className="col-md-3 col-xs-12 text-right">
            <b>{detail.cusip}</b>
        </div>
        </div>

        <div className='row vertical-offset-xs'>
        <dl className="order-detail-list" css={listCss}>
        <div className="col-md-4 col-xs-12">
            <dt>Order</dt>
            <dd>{detail.orderNo}</dd>
            <dt>Status</dt>
            <dd>{ordStatusDesc}</dd>
            <dt>Time (ET)</dt>
            <dd>{String(detail.placed).replace('ET', '').trim()}</dd>
            <dt>Transaction</dt>
            <dd>{detail.transactionType}</dd>
            <dt>Quantity</dt>
            <dd>{fmt.qty(detail.quantity)}</dd>
            <dt>Price</dt>
            <dd>{isAuction ? 'Auction' : (isNumeric(detail.clientPrice) ? '$' + fmt.price3(detail.clientPrice) : fmt.empty())}</dd>
            <dt>Acct No</dt>
            <dd>{detail['account#']}</dd>
            <dt>Solicited</dt>
            <dd>{detail.solicited || fmt.empty()}</dd>
        </div>

        <div className="col-md-4 col-xs-12">
            <dt>CUSIP</dt>
            <dd>{detail.cusip}</dd>
            <dt>Coupon</dt>
            <dd>{fmt.cpn3(detail.coupon)}</dd>
            <dt>Maturity</dt>
            <dd>{fmt.mdy(detail.maturity)}</dd>
            <dt>Trade Date</dt>
            <dd>{fmt.mdy(detail.tradeDate)}</dd>
            <dt>Settlement</dt>
            <dd>{fmt.mdy(detail.settlement)}</dd>
            <dt>Factor</dt>
            <dd>{detail.factor}</dd>
            <dt>Exec Type</dt>
            <dd>{detail.executionType || fmt.empty()}</dd>
            <dt>Trade Type</dt>
            <dd>{detail.tradeType}</dd>
        </div>

        <div className="col-md-4 col-xs-12">
            <dt>YTM</dt>
            <dd>{fmt.ytw3(detail.ytm)}</dd>
            <dt>YTC</dt>
            <dd>{fmt.ytw3(detail.ytc)}</dd>
            <dt>YTP</dt>
            <dd>{fmt.ytw3(detail.ytp)}</dd>
            <dt>YTW</dt>
            <dd>{isNumeric(detail.ytw) ? <React.Fragment>{fmt.ytw3(detail.ytw)} {fmt.mdy(detail.ytwDt)}</React.Fragment> : fmt.empty()}</dd>
            <dt>Principal</dt>
            <dd>{detail.principal || fmt.empty()}</dd>
            <dt>Accrued Int.</dt>
            <dd>{detail.accruedInterest ? <React.Fragment>{detail.accruedInterest} ({detail.accIntDays} days)</React.Fragment> : fmt.empty()}</dd>
            <dt>Trans. Fee</dt>
            <dd>{detail.estCommission || fmt.empty()}</dd>
            <dt>Net Money</dt>
            <dd>{isAuction ? fmt.empty() : (detail.netMoney || fmt.empty())}</dd>
        </div>
        </dl>
        </div>

        <div className="col-md-12 text-right text-small">
            Yields are inclusive of Transaction Fee
        </div>

        <div className="row vertical-offset-base">
        {isNote && <div
            className="col-md-8 col-xs-12 from-group"
            style={{
                paddingLeft:'0px',
                paddingRight:'0px',
                display:'none', // hide for now
            }}
        >
            <Flyout
                label="Add a note to your order (optional)"
                html="Add a note to your order (optional)"
            />
            <input type="text"
                data-name="order-detail-note"
                defaultValue={note}
                onChange={(e) => setNote(e.target.value)}
                className="form-control"
            />
        </div>}
        </div>


    </React.Fragment>
}